import { realtimeUpdate } from "../util/realtimeUpdate.ts";
import { localActions } from "../util/local.ts";
import { showEvent } from "../util/logEvent.ts";
import type {
	LocalStateUI,
	LogEventShowOptions,
	UpdateEvents,
	GameAttributesLeague,
} from "../../../../common/types.ts";
import { crossTabEmitter } from "../util/crossTabEmitter.ts";
import { confirm } from "../util/confirm.tsx";

const deleteGames = (gids: number[]) => {
	localActions.deleteGames(gids);
};

const mergeGames = (games: LocalStateUI["games"]) => {
	localActions.mergeGames(games);
};

async function realtimeUpdate2(
	updateEvents: UpdateEvents = [],
	url?: string,
	raw?: Record<string, unknown>,
) {
	await realtimeUpdate(updateEvents, url, raw);
}

const resetLeague = () => {
	localActions.resetLeague();
};

const setGameAttributes = (
	gameAttributes: Partial<GameAttributesLeague>,
	flagOverrides: LocalStateUI["flagOverrides"] | undefined,
) => {
	localActions.updateGameAttributes(gameAttributes, flagOverrides);
};

const showEvent2 = (options: LogEventShowOptions) => {
	showEvent(options);
};

const updateLocal = (obj: Partial<LocalStateUI>) => {
	localActions.update(obj);
};

const crossTabEmit = (
	parameters: Parameters<(typeof crossTabEmitter)["emit"]>,
) => {
	crossTabEmitter.emit(...parameters);
};

export default {
	confirm,
	crossTabEmit,
	deleteGames,
	mergeGames,
	realtimeUpdate: realtimeUpdate2,
	resetLeague,
	setGameAttributes,
	showEvent: showEvent2,
	updateLocal,
};
